import { useEffect, useState } from "react";
import { createNewSkuMapping, getAllInventory, getAllSKuCategories } from "../../services/AllServices";
import {setLabel, showMessage } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { NewMappingValidation } from "../../pages/MappingManagement/Validations";

const useAddNewMappingViewController = () => {

    const [skuCategory, setSkuCategory] = useState([]);
    const [showSku, setShowSku] = useState(false);
    const [inventoryList, setInventoryList] = useState([]);
    const [gwpskulist, setGwpSkuList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dropdownLoading, setDropdownLoading] = useState(false);
    const navigate = useNavigate();
  
    const fetchInventoryData = async (item_category = "GWP/Merchandise") => {
      setDropdownLoading(true);
      try {
        const responseData = await getAllInventory(item_category);
  
        const updatedData = responseData?.data?.map((item) => {
          return {
            label: setLabel(item),
            value: {
              item_sid: item?.sid,
              item_category: item?.udf1string,
              item_name: item?.description1,
              item_hs_id: item?.alu,
              item_watson_id: item?.description3,
            },
          };
        });
        setInventoryList(updatedData);
      } catch (error) {
        showMessage("error", error?.response?.data?.message || "Something went wrong");
      }
      setDropdownLoading(false);
    };
  
    const goBack = () => {
      navigate('/mapping-management')
    };
  
  
    useEffect(() => {
      const fetchCategoryData = async () => {
        setDropdownLoading(true);
        try {
          let responseData = await getAllSKuCategories();
          responseData = responseData.data.filter(
            (item) => item !== "GWP/Merchandise"
          );
          const updatedData = responseData?.map((item) => {
            return {
              label: item,
              value: item,
            };
          });
          setSkuCategory(updatedData);
  
          let gwpData = await getAllInventory("GWP/Merchandise");
  
          let updatedgwpData = gwpData?.data?.map((item) => {
            return {
              label: setLabel(item),
              value: {
                item_sid: item?.sid,
                item_category: item?.udf1string,
                item_name: item?.description1,
                item_hs_id: item?.alu,
                item_watson_id: item?.description3,
              },
            };
          });
          setGwpSkuList(updatedgwpData);
        } catch (error) {
         showMessage("error", error?.response?.data?.message || "Something went wrong");
        }
        setDropdownLoading(false);
      };
  
      fetchCategoryData();
      fetchInventoryData();
    }, []);
    const { setFieldValue, handleSubmit, errors, values, touched } = useFormik({
      initialValues: {
        gwp_sku_item: "",
        good_stock_sku_item: "",
        category: "",
      },
      validationSchema: NewMappingValidation,
  
      onSubmit: async (values) => {
        setLoading(true);
        try {
          await createNewSkuMapping({
            good_stock_sku_item: JSON.parse(values?.good_stock_sku_item),
            gwp_sku_item: JSON.parse(values?.gwp_sku_item),
          });
          showMessage("success", "New SKU to GWP mapping created");
          navigate(-1);
        } catch (error) {
          showMessage("error", error?.response?.data?.message || "Something went wrong");
        }
        setLoading(false);
      },
    });


    return {
        goBack,
        skuCategory,
        showSku,
        setShowSku,
        inventoryList,
        gwpskulist,
        fetchInventoryData,
        handleSubmit,
        values,
        setFieldValue,
        touched,
        errors,
        loading,
        dropdownLoading
    };
};

export default useAddNewMappingViewController;